import React, { useCallback, useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { Button } from '@components';
import { useNavigate } from 'react-router-dom';
import { EmprestimoService } from '@services';

export const SaibaMaisEmprestimoConscientePage = () => {
  const navigate = useNavigate();
  const [conteudoTexto, setConteudoTexto] = useState('');

  const recuperaDados = useCallback(async () => {
    const emprestimoService = new EmprestimoService();
    const layoutPaginaEmprestimoConsciente =
      await emprestimoService.getLayoutPaginaEmprestimo('CreditoConsciente');
    setConteudoTexto(layoutPaginaEmprestimoConsciente);
  }, []);

  useEffect(() => {
    recuperaDados();
  }, [recuperaDados]);

  return (
    <>
      <Helmet>
        <title>Forluz - Percentual Recebimento Renda Mensal</title>
      </Helmet>
      <h1 className="page-title mb-3">
        <strong>Crédito Consciente</strong>
      </h1>
      <hr className="my-4" />
      <div className="d-flex col-3 col-md-2 col-lg-1 justify-content-center">
        <Button
          className="justify-content-center mb-32"
          transparent
          color="orange"
          icon="arrow_back"
          onClick={() => navigate(-1)}
        >
          Voltar
        </Button>
      </div>
      <div className="card">
        <div className="card-body">
          <div dangerouslySetInnerHTML={{ __html: conteudoTexto }} />
        </div>
      </div>
    </>
  );
};
